<template>
  <div id="app">
    <nav-bar />
    <router-view />
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "@/components/NavBar.vue";

export default {
  name: "App",
  components: {
    NavBar
  }
};
</script>

<style lang="scss">
html,
body,
#app {
  font-family: "Noto Sans TC", sans-serif;
}
.required-icon-star {
  position: relative;
}
.required-icon-star::before {
  content: "*";
  position: absolute;
  left: -1rem;
  top: -0.2rem;
  font-size: 2rem;
  font-weight: 100;
  color: red;
}
.date-in-title {
  font-size: 1.5rem;
}
</style>
